import { render, staticRenderFns } from "./ProductVariantDetails.vue?vue&type=template&id=506be674&scoped=true"
import script from "./ProductVariantDetails.vue?vue&type=script&lang=js"
export * from "./ProductVariantDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantDetails.vue?vue&type=style&index=0&id=506be674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506be674",
  null
  
)

export default component.exports